import { useFeatureFlags } from 'common/hooks';

const FEATURE_FLAG_NAME = 'venue_ssio_label';

export const useVenueSSIOFeatureFlag = (): boolean => {
  const { data: featureFlagData } = useFeatureFlags([FEATURE_FLAG_NAME], {});

  return featureFlagData?.[FEATURE_FLAG_NAME] === 'on';
};
